<section class="d-flex justify-content-center">
  <div
    class="d-flex flex-column justify-content-center align-items-center faq-container"
  >
    <div class="gb-headline3 mb-16">{{ content?.header }}</div>
    <div class="gb-body1 text-center faq-body-margin">{{ content?.body }}</div>
    <div>
      <button
        (click)="openModal()"
        class="gb-primary-button faq-button d-flex justify-content-center align-items-center stat-button-link"
        data-dtm="quick links"
      >
        {{ content?.button1Text }}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="16"
          viewBox="0 0 17 16"
          fill="none"
        >
          <path
            d="M14.7904 10.4058V14.7021C14.7904 15.4178 14.2082 16 13.4925 16H1.79795C1.08222 16 0.5 15.4178 0.5 14.7021V3.00568C0.5 2.28995 1.08222 1.70773 1.79795 1.70773H6.12568C6.53546 1.70773 6.86737 2.03963 6.86737 2.44941C6.86737 2.8592 6.53546 3.1911 6.12568 3.1911H1.98337V14.5148H13.307V10.404C13.307 9.99421 13.639 9.6623 14.0487 9.6623C14.4585 9.6623 14.7904 9.99421 14.7904 10.404V10.4058ZM16.4907 0.608182C16.4889 0.595202 16.4852 0.582223 16.4815 0.569243C16.474 0.537722 16.4648 0.508054 16.4536 0.478387C16.4481 0.465407 16.4444 0.454282 16.4388 0.441303C16.4221 0.402364 16.4017 0.363426 16.3776 0.328196C16.3776 0.326341 16.3739 0.324487 16.3721 0.322633C16.3498 0.289257 16.322 0.257736 16.2942 0.228068C16.2849 0.218797 16.2775 0.21138 16.2682 0.202109C16.2441 0.179859 16.22 0.159462 16.1941 0.14092C16.1829 0.133503 16.1737 0.126086 16.1625 0.11867C16.131 0.0982733 16.0976 0.0797311 16.0643 0.0648974C16.0587 0.0630432 16.0531 0.0593348 16.0476 0.0574806H16.0457C16.0049 0.0389385 15.9641 0.0278132 15.9233 0.0185421C15.9122 0.0166879 15.9011 0.0148337 15.89 0.0129795C15.8547 0.00741685 15.8195 0.00370842 15.7824 0.00185421C15.775 0.00185421 15.7694 0 15.762 0H9.99542C9.58564 0 9.25374 0.331904 9.25374 0.741685C9.25374 1.15147 9.58564 1.48337 9.99542 1.48337H13.9709L6.75241 8.70182C6.46315 8.99108 6.46315 9.46019 6.75241 9.7513C6.89703 9.89593 7.08616 9.96825 7.27715 9.96825C7.46813 9.96825 7.65726 9.89593 7.80189 9.7513L15.0203 2.53285V6.52497C15.0203 6.93475 15.3522 7.26666 15.762 7.26666C16.1718 7.26666 16.5037 6.93475 16.5037 6.52497V0.741685C16.5037 0.69533 16.4981 0.650829 16.4907 0.608182Z"
            fill="white"
          />
        </svg>
      </button>
    </div>
  </div>
</section>

<app-modal
  [(visible)]="showModal"
  [showHeader]="false"
  [modalSize]="'modal-lg'"
>
  <div class="d-flex flex-column modal-gap">
    <div id="modal-body">
      <div
        class="gb-headline1 heavy"
        [innerHtml]="$safeNavigationMigration(content?.modalTitle)"
      ></div>
    </div>
    <div class="gb-body1">
      <div [innerHtml]="$safeNavigationMigration(content?.modalBody)"></div>
    </div>
    <div>
      <button class="gb-primary-button faq-button" (click)="goToFaqSite()">
        {{ content?.modalButtonText }}
      </button>
    </div>
  </div>
</app-modal>
